import React from "react";
import "./About.css";
import TrainingPrograms from "./TrainingPrograms";
import Alumni from "./Alumni";
import FlightTrainingLocation from "./FlightTrainingLocation";
import GroundClasses from "./GroundClasses";
import AircraftTypeRating from "./AircraftTypeRating";

import LoanAssistance from "./LoanAssistance";
import FinancePartners from "./FinancePartners";
import FAQ from "./FAQ";

import PageHeader from "./PageHeader";
function About() {
  return (
    <>
       <PageHeader
        title="About Us"
        bgImage="assets/img/about-img.png"
      />

      {/* ===== Director Message / History Intro ===== */}
 <section className="about-hero">
  <div className="container">
    <div className="row align-items-center justify-content-between g-4">

      {/* LEFT: text */}
      <div className="col-lg-6">
        <div className="about-hero-text">

          <p className="about-label text-uppercase mb-2">
            Welcome to The Pilot Guide
            <span className="by-rsa"> · An RSA Initiative</span>
          </p>

          <h1 className="about-title mb-4">
            A Complete Airline Pilot Training Academy
          </h1>

          <p className="about-quote mb-4">
            Welcome to <strong>The Pilot Guide</strong> — where dreams take flight.
            An initiative of <strong>Right Source Aviation (RSA)</strong>, we go beyond traditional flight training.
            We mentor, guide, and prepare aspiring pilots for a successful airline career with uncompromising standards of quality and training excellence.
          </p>

          <p className="about-body mb-4">
            In this dynamic aviation ecosystem, RSA delivers a comprehensive range of pilot training programs including
            <strong> Offline, Online (Hybrid), and On-Demand DGCA CPL & ATPL coaching</strong>,
            CPL Flight Training, Type Rating, and more — all designed to meet global airline standards.
          </p>

          <p className="about-body mb-4">
            Our commitment to excellence has been recognised with the
            <strong> “Best Aviation & Airline Pilot Training Academy”</strong> award,
            along with recognition from the <strong>American Merit Council</strong>,
            reflecting our consistent success rate and student achievements.
          </p>

          <p className="about-body mb-4">
            Led by <strong>Capt.Vijay</strong>, with over <strong>15 years of airline and aviation experience</strong>,
            RSA is built on trust, integrity, and transparency.
            With partnerships across <strong>20+ flight schools in 9 countries</strong>,
            we support our students at every stage — prioritising skill, safety, confidence, and well-being
            as they progress toward becoming professional commercial airline pilots.
          </p>

        </div>
      </div>

      {/* RIGHT: image */}
      <div className="col-lg-5">
        <div className="about-image-card">
          <img
            src={`${process.env.PUBLIC_URL}/assets/img/About-HOmepage-01.jpg`}
            className="img-fluid about-image"
            alt="Right Source Aviation Training"
          />
        </div>
      </div>

    </div>
  </div>
</section>


      {/* ===== Vision & Services (NEW) ===== */}
     <section className="vision-section">
  <div className="container">

    {/* Heading */}
    <div className="row justify-content-center text-center mb-5">
      <div className="col-lg-8">
        <p className="about-label text-uppercase mb-2">Our Vision</p>
        <h2 className="vision-title">
          Shaping Confident & Skilled Professional Pilots
        </h2>
        <p className="vision-subtitle">
          Our vision is to be India’s most trusted platform for DGCA exam
          preparation and aviation mentoring, combining technology with
          expert classroom guidance.
        </p>
      </div>
    </div>

    {/* Cards */}
    <div className="row gx-4 gy-4">

      {[
        { icon: "fa-laptop-code", title: "Online Mock Tests", text: "Full-length and chapter-wise DGCA-style mock tests with instant analysis and performance insights." },
        { icon: "fa-chalkboard-teacher", title: "Classroom Coaching", text: "Expert-led interactive sessions covering Navigation, Meteorology, Regulations & Technical subjects." },
        { icon: "fa-mobile-alt", title: "Mobile App Learning", text: "Practice anytime with app-based tests, bookmarks, and progress tracking dashboards." },
        { icon: "fa-comments", title: "Doubt-Solving Support", text: "Dedicated doubt-clearing sessions and personalised mentoring for weak areas." },
        { icon: "fa-chart-line", title: "Performance Analytics", text: "Advanced analytics on accuracy, speed, and topic-wise strengths to optimise preparation." },
        { icon: "fa-user-tie", title: "Career Guidance", text: "End-to-end guidance from DGCA exams to flight training and airline interview readiness." }
      ].map((item, i) => (
        <div className="col-md-4" key={i}>
          <div className="vision-card">
            <div className="vision-icon">
              <i className={`fas ${item.icon}`}></i>
            </div>
            <h5 className="vision-card-title">{item.title}</h5>
            <p className="vision-card-text">{item.text}</p>
          </div>
        </div>
      ))}

    </div>
  </div>
</section>

 

      	{/* ============================ Call To Action End ================================== */}
      <TrainingPrograms />
      <Alumni />
      <FlightTrainingLocation />
      <GroundClasses />
      <AircraftTypeRating />
     
      <LoanAssistance />
      <FinancePartners />
      <FAQ />
    </>
  );
}

export default About;
